import { Body1 } from "../typography/Body1.js";
import "react";
import { notifications } from "@mantine/notifications";
import { jsx } from "react/jsx-runtime";

//#region src/components/notification/Notifications.tsx
const originalShow = notifications.show;
const revisedShow = (notification) => {
	const { color, message } = notification;
	const isMessageString = typeof message === "string";
	let childEl;
	if (isMessageString) childEl = /* @__PURE__ */ jsx(Body1, {
		color: "white",
		children: message
	});
	else childEl = notification.message;
	return originalShow({
		withCloseButton: isMessageString,
		...notification,
		message: childEl,
		__vars: {
			"--bkg-color": `var(--mantine-color-${color ?? "gray"}-9)`,
			"--hover-bkg-color": `var(--mantine-color-${color ?? "gray"}-7)`
		}
	});
};
const notifications$1 = {
	...notifications,
	show: revisedShow
};

//#endregion
export { notifications$1 as notifications };